import {
  SexLimitationOptions,
  ExerciseLevelOptions,
  OtherConditionOptions,
} from './types'
import { Gender, ProgramLevel } from '../Programs'
import { SearchParams } from '@/externals/gyym/user/facilities'

export const FACILITY_SEARCH_HISTORY_KEY = 'gyym:FacilitySearchHistory' as const

export const sexLimitationOptions: SexLimitationOptions = [
  { label: '女性専用', value: Gender.WOMEN },
  { label: '男性専用', value: Gender.MEN },
  { label: '性別制限なし', value: Gender.NONE },
]

export const exerciseLevelOptions: ExerciseLevelOptions = [
  { label: '入門', value: ProgramLevel.ENTRY },
  { label: '初級', value: ProgramLevel.BEGINNER },
  { label: '中級', value: ProgramLevel.INTERMEDIATE },
  { label: '上級', value: ProgramLevel.ADVANCED },
]

export const EXCLUDE_FULL_RESERVATIONS_KEY = 'excludeFullReservations' as const

export const otherConditionOptions: OtherConditionOptions = [
  { label: '空席の予約枠のみを表示する', value: EXCLUDE_FULL_RESERVATIONS_KEY },
]

export const initialSearchParams: SearchParams = {
  facilityName: null,
  activityIds: [],
  areaIds: [],
  sexLimitations: [],
  exerciseLevels: [],
  dates: [],
  startTimeFrom: null,
  startTimeTo: null,
  priceFrom: null,
  priceTo: null,
  excludeFullReservations: false,
  cityCode: null,
}
